<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select
          v-model="queryParams.shopId"
          class="!w-240px"
          clearable
          filterable
          placeholder="请选择店铺"
          @change="handleQuery"
        >
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="物业类型" prop="propertyType">
        <el-select
          v-model="queryParams.propertyType"
          class="!w-240px"
          clearable
          placeholder="请选择物业类型"
        >
          <el-option label="酒店" :value="0" />
          <el-option label="民宿" :value="1" />
          <el-option label="客栈" :value="2" />
          <el-option label="公寓" :value="3" />
          <el-option label="青年旅舍" :value="4" />
          <el-option label="度假村" :value="5" />
        </el-select>
      </el-form-item>
      <el-form-item label="经营模式" prop="operationMode">
        <el-select
          v-model="queryParams.operationMode"
          class="!w-240px"
          clearable
          placeholder="请选择经营模式"
        >
          <el-option label="平台自营" value="SELF_OPERATED" />
          <el-option label="平台托管" value="PLATFORM_MANAGED" />
          <el-option label="第三方入驻" value="THIRD_PARTY" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:shop-config:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="店铺ID" prop="shopId" min-width="100" />
      <el-table-column align="center" label="物业类型" prop="propertyType" min-width="120">
        <template #default="scope">
          <el-tag v-if="scope.row.propertyType === 0" type="primary">酒店</el-tag>
          <el-tag v-else-if="scope.row.propertyType === 1" type="success">民宿</el-tag>
          <el-tag v-else-if="scope.row.propertyType === 2" type="warning">客栈</el-tag>
          <el-tag v-else-if="scope.row.propertyType === 3" type="info">公寓</el-tag>
          <el-tag v-else-if="scope.row.propertyType === 4" type="info">青年旅舍</el-tag>
          <el-tag v-else-if="scope.row.propertyType === 5" type="danger">度假村</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="经营模式" prop="operationMode" min-width="120">
        <template #default="scope">
          {{
            scope.row.operationMode === 'SELF_OPERATED'
              ? '平台自营'
              : scope.row.operationMode === 'PLATFORM_MANAGED'
                ? '平台托管'
                : '第三方入驻'
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="佣金率" prop="commissionRate" min-width="90">
        <template #default="scope">{{ scope.row.commissionRate ?? 0 }}%</template>
      </el-table-column>
      <el-table-column align="center" label="结算周期" prop="settleCycle" min-width="90" />
      <el-table-column align="center" label="入住时间" prop="checkInTime" min-width="100" />
      <el-table-column align="center" label="退房时间" prop="checkOutTime" min-width="100" />
      <el-table-column align="center" label="钟点房" prop="hourlyRoomEnabled" min-width="80">
        <template #default="scope">
          <el-tag v-if="scope.row.hourlyRoomEnabled === 1" type="success">启用</el-tag>
          <el-tag v-else type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="多人入住" prop="multiGuestEnabled" min-width="80">
        <template #default="scope">
          <el-tag v-if="scope.row.multiGuestEnabled === 1" type="success">启用</el-tag>
          <el-tag v-else type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="自动确认" prop="autoConfirm" min-width="80">
        <template #default="scope">
          <el-tag v-if="scope.row.autoConfirm === 1" type="success">是</el-tag>
          <el-tag v-else type="info">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="超售限制" prop="oversellLimit" min-width="80" />
      <el-table-column align="center" label="延迟退房费" prop="lateCheckoutFee" min-width="100">
        <template #default="scope">
          {{ scope.row.lateCheckoutFee != null ? '￥' + scope.row.lateCheckoutFee : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="提前入住费" prop="earlyCheckinFee" min-width="100">
        <template #default="scope">
          {{ scope.row.earlyCheckinFee != null ? '￥' + scope.row.earlyCheckinFee : '-' }}
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="150">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:shop-config:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:shop-config:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle" width="700px">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="120px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="formData.shopId" placeholder="请选择店铺" filterable clearable>
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="物业类型" prop="propertyType">
        <el-radio-group v-model="formData.propertyType">
          <el-radio :value="0">酒店</el-radio>
          <el-radio :value="1">民宿</el-radio>
          <el-radio :value="2">客栈</el-radio>
          <el-radio :value="3">公寓</el-radio>
          <el-radio :value="4">青年旅舍</el-radio>
          <el-radio :value="5">度假村</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="经营模式" prop="operationMode">
        <el-radio-group v-model="formData.operationMode">
          <el-radio value="SELF_OPERATED">平台自营</el-radio>
          <el-radio value="PLATFORM_MANAGED">平台托管</el-radio>
          <el-radio value="THIRD_PARTY">第三方入驻</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="平台佣金率" prop="commissionRate">
        <el-input-number
          v-model="formData.commissionRate"
          :min="0"
          :max="100"
          :precision="2"
          class="!w-240px"
        />
        <span class="ml-8px">%</span>
      </el-form-item>
      <el-form-item label="结算周期" prop="settleCycle">
        <el-select v-model="formData.settleCycle" class="!w-240px">
          <el-option label="实时" value="INSTANT" />
          <el-option label="日结" value="DAILY" />
          <el-option label="周结" value="WEEKLY" />
          <el-option label="月结" value="MONTHLY" />
        </el-select>
      </el-form-item>
      <el-form-item label="自动结算" prop="autoSettle">
        <el-switch v-model="formData.autoSettle" :active-value="1" :inactive-value="0" />
      </el-form-item>
      <el-form-item label="入住时间" prop="checkInTime">
        <el-time-picker
          v-model="formData.checkInTime"
          format="HH:mm"
          value-format="HH:mm"
          placeholder="请选择入住时间"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="退房时间" prop="checkOutTime">
        <el-time-picker
          v-model="formData.checkOutTime"
          format="HH:mm"
          value-format="HH:mm"
          placeholder="请选择退房时间"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="钟点房" prop="hourlyRoomEnabled">
        <el-radio-group v-model="formData.hourlyRoomEnabled">
          <el-radio :value="1">启用</el-radio>
          <el-radio :value="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="多人入住" prop="multiGuestEnabled">
        <el-radio-group v-model="formData.multiGuestEnabled">
          <el-radio :value="1">启用</el-radio>
          <el-radio :value="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="自动确认" prop="autoConfirm">
        <el-radio-group v-model="formData.autoConfirm">
          <el-radio :value="1">是</el-radio>
          <el-radio :value="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="超售限制" prop="oversellLimit">
        <el-input-number v-model="formData.oversellLimit" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="取消政策" prop="cancelPolicy">
        <el-input
          v-model="formData.cancelPolicy"
          :rows="2"
          placeholder="请输入取消政策"
          type="textarea"
        />
      </el-form-item>
      <el-form-item label="押金政策" prop="depositPolicy">
        <el-switch
          v-model="depositPolicyForm.required"
          active-text="收取押金"
          inactive-text="不收取"
        />
        <el-input-number
          v-if="depositPolicyForm.required"
          v-model="depositPolicyForm.amount"
          :min="0"
          :precision="2"
          class="ml-12px"
        />
      </el-form-item>
      <el-form-item label="延迟退房费" prop="lateCheckoutFee">
        <el-input-number
          v-model="formData.lateCheckoutFee"
          :min="0"
          :precision="2"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="提前入住费" prop="earlyCheckinFee">
        <el-input-number
          v-model="formData.earlyCheckinFee"
          :min="0"
          :precision="2"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="儿童政策" prop="childPolicy">
        <el-input
          v-model="formData.childPolicy"
          :rows="2"
          placeholder="请输入儿童政策"
          type="textarea"
        />
      </el-form-item>
      <el-form-item label="宠物政策" prop="petPolicy">
        <el-input
          v-model="formData.petPolicy"
          :rows="2"
          placeholder="请输入宠物政策"
          type="textarea"
        />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="formData.remark" :rows="3" placeholder="请输入备注" type="textarea" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import * as ShopConfigApi from '@/api/hotel/shopConfig'
import { getAllHotelShopSimpleList as getShopSimpleList } from '@/api/hotel/platformShop'

defineOptions({ name: 'HotelShopConfig' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  shopId: undefined,
  propertyType: undefined,
  operationMode: undefined
})
const queryFormRef = ref()

// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

const getList = async () => {
  loading.value = true
  try {
    const data = await ShopConfigApi.getShopConfigPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const depositPolicyForm = reactive({ required: true, amount: 500 })
const formData = ref<ShopConfigApi.ShopConfigVO>({
  id: undefined,
  shopId: undefined,
  propertyType: 0,
  operationMode: 'SELF_OPERATED',
  autoSettle: 0,
  settleCycle: 'INSTANT',
  commissionRate: 0,
  status: 0,
  checkInTime: '14:00',
  checkOutTime: '12:00',
  hourlyRoomEnabled: 0,
  multiGuestEnabled: 1,
  autoConfirm: 0,
  oversellLimit: 0,
  cancelPolicy: '',
  depositPolicy: '',
  lateCheckoutFee: 0,
  earlyCheckinFee: 0,
  childPolicy: '',
  petPolicy: '',
  remark: '',
  createTime: undefined as any
})
const formRules = reactive({
  shopId: [{ required: true, message: '店铺不能为空', trigger: 'change' }],
  propertyType: [{ required: true, message: '物业类型不能为空', trigger: 'change' }],
  checkInTime: [{ required: true, message: '入住时间不能为空', trigger: 'change' }],
  checkOutTime: [{ required: true, message: '退房时间不能为空', trigger: 'change' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      const data = await ShopConfigApi.getShopConfig(id)
      formData.value = {
        ...formData.value,
        ...data,
        propertyType: Number(data.propertyType)
      }
      try {
        Object.assign(depositPolicyForm, JSON.parse(formData.value.depositPolicy || '{}'))
      } catch {
        Object.assign(depositPolicyForm, { required: true, amount: 500 })
      }
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    formData.value.depositPolicy = JSON.stringify(depositPolicyForm)
    const data = {
      ...formData.value,
      propertyType: Number(formData.value.propertyType)
    }
    if (formType.value === 'create') {
      await ShopConfigApi.createShopConfig(data)
      message.success(t('common.createSuccess'))
    } else {
      await ShopConfigApi.updateShopConfig(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  Object.assign(depositPolicyForm, { required: true, amount: 500 })
  formData.value = {
    id: undefined,
    shopId: 0,
    propertyType: 0,
    operationMode: 'SELF_OPERATED',
    autoSettle: 0,
    settleCycle: 'INSTANT',
    commissionRate: 0,
    status: 0,
    checkInTime: '14:00',
    checkOutTime: '12:00',
    hourlyRoomEnabled: 0,
    multiGuestEnabled: 1,
    autoConfirm: 0,
    oversellLimit: 0,
    cancelPolicy: '',
    depositPolicy: '',
    lateCheckoutFee: 0,
    earlyCheckinFee: 0,
    childPolicy: '',
    petPolicy: '',
    remark: '',
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await ShopConfigApi.deleteShopConfig(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
  getShopList()
})
</script>
